export enum DrainConstants {
  SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT = 'drain/SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT',
  SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT_PNNV = 'drain/SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT_PNNV',
  SET_KEY = 'drain/SET_KEY',
  SET_DATE = 'drain/SET_DATE',
  SET_TIME = 'drain/SET_TIME',
  SET_ASSESSED_BY = 'drain/SET_ASSESSED_BY',
  SET_ROLE_PERFORMING = 'drain/SET_ROLE_PERFORMING',
  SET_ROLE_PERFORMING_PNNV = 'drain/SET_ROLE_PERFORMING_PNNV',
  SET_PROCEDURE_COMPLICATIONS = 'drain/SET_PROCEDURE_COMPLICATIONS',
  SET_RESPONSE = 'drain/SET_RESPONSE',
  SET_RESPONSE_PNNV = 'drain/SET_RESPONSE_PNNV',
  SET_AUTHORIZATION = 'drain/SET_AUTHORIZATION',
  SET_COMMENTS = 'drain/SET_COMMENTS',
  SET_TYPE = 'drain/SET_TYPE',
  SET_SUCCESSFUL_ATTEMPT = 'drain/SET_SUCCESSFUL_ATTEMPT',
  SET_PTA = 'drain/SET_PTA',
  SET_ATTEMPTS = 'drain/SET_ATTEMPTS',
  SET_ACTION = 'drain/SET_ACTION',
  SET_PROCEDURE = 'drain/SET_PROCEDURE',
  SET_SIZE = 'drain/SET_SIZE',
  SET_SIZE_UNIT = 'drain/SET_SIZEUNIT',
  SET_DRAIN_SUCTION = 'drain/SET_DRAINSUCTION',
  SET_CHEST_SUCTION = 'drain/SET_CHESTSUCTION',
  SET_FOLEY_COLOR = 'drain/SET_FOLEYCOLOR',
  SET_CSF_COLOR = 'drain/SET_CSFCOLOR',
  SET_CAPPED = 'drain/SET_CAPPED',
  SET_SIDE = 'drain/SET_SIDE',
  SET_LOCATION = 'drain/SET_LOCATION',
  SET_INTERCOSTAL_SPACE = 'drain/SET_INTERCOSTAL_SPACE',
  SET_DEPTH = 'drain/SET_DEPTH',
  SET_FIELD2 = 'drain/SET_FIELD2',
  SET_DATE_TIME = 'drain/SET_DATE_TIME',
  SET_UPDATE_INPUT_ROWS = 'drain/SET_UPDATE_INPUT_ROWS',
  SET_ADD_TO_TIMELINE = 'drain/SET_ADD_TO_TIMELINE',
  SET_STATE = 'drain/SET_STATE',
  SAVE_DRAIN = 'drain/SAVE_DRAIN',
  ON_SELECT_DRAIN = 'drain/ON_SELECT_DRAIN',
  SET_DRAIN_DEFAULTS = 'drain/SET_DRAIN_DEFAULTS',
  RESET_TO_INITIAL_STATE = 'drain/RESET_TO_INITIAL_STATE',
  RESET_STATE = 'drain/RESET_STATE',
}

export enum DrainActionIds {
  CHEST_TUBE = 'Chest Tube',
  COLOSTOMY = 'Colostomy',
  FOLEY = 'Foley',
  ILEOSTOMY = 'Ileostomy',
  NG_TUBE = 'NG Tube',
  NEEDLE_THORACOSTOMY = 'Needle Thoracostomy Drain',
  OG_TUBE = 'OG Tube',
  SIMPLE_FINGER_THORACOSTOMY = 'Simple/Finger Thoracostomy Drain',
  VENTRICULOSTOMY = 'Ventriculostomy',
}
